"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToIframe = void 0;
const scrollToIframe = () => {
    window.parent.postMessage({ action: 'scrollToIframe' }, '*');
};
exports.scrollToIframe = scrollToIframe;
